import React, { useEffect, useState } from 'react';
import { Formik } from 'formik';

import encode from '../../../../shared/utils/encodeToUrl';
import useLogin from '../hooks/useLogin';
import SharedLoginForm from '../shared/SharedLoginForm';
import { LoginSchema } from '../../../../shared/utils/loginSchemaHelper';

const LoginForm = () => {
  const [googleLoginWidth, setGoogleLoginWidth] = useState('322');

  const {
    handleLogin,
  } = useLogin();

  useEffect(() => {
    const handleResize = () => {
      setGoogleLoginWidth(window.innerWidth < 600 ? '270' : '322');
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <Formik
      initialValues={{
        client_id: process.env.CLIENT_ID,
        client_secret: process.env.CLIENT_SECRET,
        grant_type: 'password',
        password: '',
        scope: 'offline_access',
        username: '',
      }}
      onSubmit={(values) => {
        handleLogin(encode(values));
      }}
      validationSchema={LoginSchema}
      render={({
        errors,
        handleSubmit,
        touched,
        values,
      }) => (
        <SharedLoginForm
          errors={errors}
          googleLoginWidth={googleLoginWidth}
          handleSubmit={handleSubmit}
          touched={touched}
          values={values}
        />
      )}
    />
  );
};

export default LoginForm;
